import "../../style/topBar.css";
import lovdataProLogo from "../../assets/lovdata-pro-logo.svg";
import karnovLogo from "../../assets/KarnovLogo.svg";

const TopBar = () => {
  return (
    <div className="TopBarContainer">
      <div className="LovdataProLogoContainer">
        <a href="https://lovdata.no/pro/#karnov" title="Lovdata Pro">
          <img className="LovdataProLogo" src={lovdataProLogo} alt="Lovdata Pro logo" />
        </a>
      </div>

      <div className="KarnovLogoContainer">
        <a href="https://www.karnovgroup.no/" title="Karnov Group Norway">
          <img className="KarnovLogo" src={karnovLogo} alt="Karnov Group Norway logo" />
        </a>
      </div>
    </div>
  );
};

export default TopBar;
